const rootEl = document.getElementById('collectionApp');

const productComponent = {
    components: {
        'wishlistlink': wishlistLink
    },
    data() {
        return {
            imageRatio: '1',
            smallestCanvasSize: null
        }
    },
    inject: ['productLoading','discount','productSizes','productMaterials'],
    emits: ['quickview'],
    created() {
        const img = new Image();
        img.onload = () => {
            const width = img.width
            const height = img.height
            this.imageRatio = this.getAspectRatio(width, height);
            this.smallestCanvasSize = this.canvasSize();
        }
        img.src = this.product.thumbnail_url
    },
    template: `<a v-bind:href="getUrl(product,productType)" :class="{loading: productLoading == product.id}">
                <span class="product-image">
                    <img :src=imageUrl alt="" loading="lazy">
                    <span class="quickview" @click.stop.prevent="quickview()">View Larger</span>
                </span>
                <div class="item-content">
                <span class="item-name"><span class="link-view">{{productTitle}}</span><wishlistlink :id="product.id" :type="productType" :url="getUrl(product,productType)" :image="imageUrl" :title="productTitle"></wishlistlink></span>
                <p class="canvas-size" v-if="this.type === 'canvas' && this.smallestCanvasSize"><em v-html="smallestCanvasSize.size"></em> <span>multiple sizes</span></p>
                <span class="price-container" v-if="this.type === 'canvas'">
                    <label>From</label>
                    <span class="prices">
                        <span class="special-price">{{formatCurrency(specialPrice)}}</span>
                        <span class="old-price">{{formatCurrency(price)}}</span>
                        <span class="discount">{{discount}}% off</span>
                    </span>
                </span>
                <span class="add-to-links"><span class="product-button">Choose Options</span></span>
                </div>
              </a>`,
    props: {
        product: Object,
        type: String
    },
    computed: {
        imageUrl() {
            return (this.type === 'canvas') ? this.previewUrl + this.product.thumbnail_url : this.product.thumbnail_url;
        },
        productType() {
            /*
            let title = this.product.title.toLowerCase().replace(/\./g, ' ');
            if(this.type !== 'canvas' && title.indexOf('wallpaper') !== -1) {
                return 'wallpaper';
            }

             */
            return this.type;
        },
        productTitle() {
            let title = this.product.title.toLowerCase().replace(/\./g, ' ');
            if(this.type === 'canvas') {
                if (title.indexOf('canvas print') === -1) {
                    title += ' canvas print';
                }
            } else if(this.type === 'wallpaper') {
                if(title.indexOf('wallpaper') === -1) {
                    title += ' wallpaper';
                }
            } else {
                if(title.indexOf('wall mural') === -1) {
                    title += ' wall mural';
                }
            }
            return title;
        },
        price() {
            return this.smallestCanvasSize ? this.smallestCanvasSize.price : '';
        },
        specialPrice() {
            return this.smallestCanvasSize ? this.smallestCanvasSize.price * (1 - (Number(this.discount) / 100)) : '';
        },
    },
    methods: {
        quickview() {
            this.$emit('quickview', [this.product, this.productTitle, this.productType]);
        },
        canvasSize() {
            if(this.type === 'canvas') {
                const size = this.productSizes.find(size => {
                    if(this.imageRatio === '3') {
                        return (
                            size.rendered_size === 'medium' &&
                            size.aspect_ratio === this.imageRatio
                        )
                    } else {
                        return (
                            size.rendered_size === 'small' &&
                            size.aspect_ratio === this.imageRatio
                        )
                    }
                })
                return size;
            }
        }
    }
}
const filtersComponent = {
    inject: ['appliedFilters','cleanFilters','loading'],
    emits: ['updateFilters'],
    data() {
        return {
            filters: {
                'type': {
                    'all': 'All',
                    'photo': 'Photos',
                    'illustration': 'Illustrations',
                    'vector': 'Vectors',
                },
                'orientation': {
                    'all': 'All',
                    'horizontal': 'Horizontal',
                    'vertical': 'Vertical',
                    'square': 'Square',
                    'panoramic': 'Panoramic',
                },
                'size': {
                    'units': {
                        'inches': 'Inches',
                        'centimeters': 'Centimeters',
                    }
                }
            },
            open: false,
            openFilters: {
                'type': false,
                'orientation': false,
                'size': false,
                'color': false,
            },
            activeFilters: this.cloneObject(this.appliedFilters),
            colors: ['#330000','#331900','#333300','#193300','#003300','#003319','#003333','#001933','#000033','#190033','#330033','#330019','#000000','#660000','#663300','#666600','#336600','#006600','#006633','#006666','#003366','#000066','#330066','#660066','#660033','#202020','#990000','#994C00','#999900','#4C9900','#009900','#00994C','#009999','#004C99','#000099','#4C0099','#990099','#99004C','#404040','#CC0000','#CC6600','#CCCC00','#66CC00','#00CC00','#00CC66','#00CCCC','#0066CC','#0000CC','#6600CC','#CC00CC','#CC0066','#606060','#FF0000','#FF8000','#FFFF00','#80FF00','#00FF00','#00FF80','#00FFFF','#0080FF','#0000FF','#7F00FF','#FF00FF','#FF007F','#808080','#FF3333','#FF9933','#FFFF33','#99FF33','#33FF33','#33FF99','#33FFFF','#3399FF','#3333FF','#9933FF','#FF33FF','#FF3399','#A0A0A0','#FF6666','#FFB266','#FFFF66','#B2FF66','#66FF66','#66FFB2','#66FFFF','#66B2FF','#6666FF','#B266FF','#FF66FF','#FF66B2','#C0C0C0','#FF9999','#FFCC99','#FFFF99','#CCFF99','#99FF99','#99FFCC','#99FFFF','#99CCFF','#9999FF','#CC99FF','#FF99FF','#FF99CC','#E0E0E0','#FFCCCC','#FFE5CC','#FFFFCC','#E5FFCC','#CCFFCC','#CCFFE5','#CCFFFF','#CCE5FF','#CCCCFF','#E5CCFF','#FFCCFF','#FFCCE5','#FFFFFF']
        }
    },
    mounted() {

    },
    computed: {
        hasApplied() {
            for(const filter in this.appliedFilters) {
                if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                    return true;
                }
            }
            return false;
        },
        countApplied() {
            let count = 0;
            for(const filter in this.appliedFilters) {
                if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                    count++
                }
            }
            return count;
        },
        mobileFiltersTitle() {
            if(this.countApplied > 0) {
                return 'Filters (' + this.countApplied + ')';
            } else {
                return 'Filters';
            }
        }
    },
    template: `
    <a href="#" class="toggle-mobile-filters" :class="{'active': hasApplied}" @click.prevent="open = !open" v-text="mobileFiltersTitle"></a>
    <div class="filters-container" :class="{'open': open, 'loading': loading}">
    <ul class="shop-filters">
        <li class="label">Filter by:</li>
        <li :class="{'open': openFilters.type}">
            <a href="#" class="toggle-filter" @click.prevent="openFilters.type = !openFilters.type">Type</a>
            <ul>
                <li v-for="(value, key, index) in filters.type"><input type="radio" :value="key" :id="'image-type-'+index" v-model="activeFilters.type"> <label :for="'image-type-'+index">{{value}}</label></li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
        <li :class="{'open': openFilters.orientation}">
            <a href="#" class="toggle-filter" @click.prevent="openFilters.orientation = !openFilters.orientation">Orientation</a>
            <ul>
                <li v-for="(value, key, index) in filters.orientation" :class="'image-label '+key+'-image'"><input type="radio" :value="key" :id="'image-orientation-'+index" v-model="activeFilters.orientation"> <label :for="'image-orientation-'+index">{{value}}</label></li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
        <!--
        <li :class="{'open': openFilters.size}">
            <a href="#" class="toggle-filter" @click.prevent="openFilters.size = !openFilters.size">Size</a>
            <ul>
                <li class="units">
                    <label for="measurement">Units</label>
                    <p v-for="(value, key, index) in filters.size.units"><input type="radio" :value="key" :id="'units-'+index" v-model="activeFilters.units"> <label :for="'units-'+index">{{value}}</label></p>
                </li>
                <li>
                    <label for="min_width">Min. Width</label>
                    <input id="min_width" type="text" placeholder="Min. Width" class="type-text" v-model.number="activeFilters.min_width" />
                </li>
                <li>
                    <label for="min_height">Min. Height</label>
                    <input id="min_height" type="text" placeholder="Min. Height" class="type-text" v-model.number="activeFilters.min_height" />
                </li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
        -->
        <li class="color-filter" :class="{'open': openFilters.color}">
            <span>Color</span>
            <input placeholder="None" class="color-picker" v-model="activeFilters.color" readonly @click.prevent="openFilters.color = !openFilters.color" />
            <a href="#" class="toggle-filter" @click.prevent="openFilters.color = !openFilters.color">Color</a>
            <ul>
                <li v-for="(color, index) in colors"><input type="radio" v-model="activeFilters.color" :value="color" :id="'color-picker-'+index" class="sr-only"><label :for="'color-picker-'+index" :style="{'background':color}"><span class="sr-only">{{color}}</span></label></li>
                <li class="action"><a href="#" @click.prevent="apply()">Apply</a></li>
            </ul>
        </li>
    </ul>
    <div class="applied-filters" :class="{'has-filters': hasApplied}">
        <a href="#" class="remove-all" v-if="hasApplied" @click.prevent="reset()">remove all filters</a>
        <a href="#" class="text-link" v-if="appliedFilters.type !== 'all'" @click.prevent="remove('type','all')">{{filters.type[appliedFilters.type]}}</a>
        <a href="#" :class="'text-link image-link '+appliedFilters.orientation+'-image'" v-if="appliedFilters.orientation !== 'all'" @click.prevent="remove('orientation','all')">{{filters.orientation[appliedFilters.orientation]}}</a>
        <a href="#" class="text-link" v-if="appliedFilters.color !== null" @click.prevent="remove('color',null)">Color: {{appliedFilters.color}}</a>
    </div>
    </div>
    `,
    props: {

    },
    methods: {
        apply() {
            this.closeAll();
            this.$emit('updateFilters', this.cloneObject(this.activeFilters));
        },
        reset() {
            this.activeFilters = this.cloneObject(this.cleanFilters);
            this.$emit('updateFilters', this.cloneObject(this.cleanFilters));
        },
        remove(type,value) {
            this.activeFilters[type] = value;
            this.apply();
        },
        closeAll() {
            for(const filter in this.openFilters) {
                this.openFilters[filter] = false;
            }
        }
    }
}
const facetsComponent = {
    inject: ['page','limit'],
    data() {
        return {}
    },
    template: `<form id="FacetFiltersForm" class="facets__form">
            <div class="product-count" role="status">
              <div class="product-count__text text-body"><span id="ProductCountDesktop" v-html="itemsCount()"></span></div>
            </div>
          </form>`,
    props: {
        total: Number
    },
    methods: {
        itemsCount() {
            let html = '';
            if(this.total === 1) {
                html = '<span class="collection-item-count">1 of 1</span>';
            } else if (this.total > 1) {
                let from = (this.page * this.limit) - this.limit + 1;
                let to = this.page * this.limit;
                if(to > this.total) {
                    to = this.total;
                }
                html = '<span class="collection-item-count">You\'ve viewed '+ to + ' of ' +this.total.toLocaleString()+' images</span>';
            }
            return html;
        }
    }
}
const paginationComponent = {
    emits: ['paginate'],
    inject: ['page','loading'],
    template: `
    <nav aria-label="Page navigation" :data-page="currentPage" class="visually-hidden">
      <ul class="pagination pagination-lg" :class="{'loading': loading}">
        <li class="page-item"><button type="button" class="page-link" :class="{ disabled: currentPage === 1}" @click.stop.prevent="goto(1)">&laquo;</button></li>
        <li class="page-item"><button type="button" class="page-link" :class="{ disabled: currentPage === 1}" @click.stop.prevent="prev()">&lsaquo;</button></li>
        <li class="page-item" v-for="pageNumber in currentPages"><button type="button" class="page-link" :class="{ active: currentPage === pageNumber}" @click.stop.prevent="goto(pageNumber)">{{pageNumber}}</button></li>
        <li class="page-item"><button type="button" @click.stop.prevent="next()" :class="{ disabled: currentPage >= pages.length}" class="page-link">&rsaquo;</button></li>
        <li class="page-item"><button type="button" @click.stop.prevent="goto(pages.length)" :class="{ disabled: currentPage >= pages.length}" class="page-link">&raquo;</button></li>
      </ul>
    </nav>`,
    props: {
        pages: Array
    },
    computed: {
        currentPage() {
            return this.page;
        },
        currentPages() {
            if(this.currentPage < 4) {
                return this.pages.slice(0, 5);
            } else {
                return this.pages.slice(this.currentPage-3, this.currentPage+2);
            }
        }
    },
    methods: {
        goto(pageNumber) {
            this.$emit('paginate',pageNumber);
        },
        prev() {
            this.$emit('paginate',(this.currentPage-1));
        },
        next() {
            this.$emit('paginate',(this.currentPage+1));
        }
    }
}
const collectionComponent = {
    components: {
        'product': productComponent,
        'facets': facetsComponent,
        'filters': filtersComponent,
        'wishlistlink': wishlistLink,
        'pagination': paginationComponent
    },
    inject: ['loading','loaded','hasFiltersInUrl','hasFilters','page','limit','addAdobeProducts'],
    emits: ['paginate','quickview','updateLimit','updateFilters','infiniteScroll'],
    template: `
    <div id="main-collection-filters" v-if="loaded && products.length > 0">
      <div class="facets-container">
        <div class="toolbar">
          <div class="product-count">{{this.total.toLocaleString()}} images</div>
          <filters v-if="addAdobeProducts" @update-filters="updateFilters"></filters>
        </div>
        <p class="refine-results" v-if="subcategories && subcategories.length > 0 && false">
            <span>Refine results:</span>
            <a v-for="subcategory in subcategories" :href="subcategory.url">{{subcategory.name}}</a>
        </p>
      </div>
    </div>
    <div id="ProductGridContainer" class="api-collection-grid" :class="classObject">
      <ul class="messages" v-if="loaded && products.length === 0"><li class="error-msg"><span>No products found</span></li></ul>
      <div v-if="loaded && products.length === 0 && type === 'wallpaper'"><p>Please shop by <a href="/collections/wallpaper">Subject</a></p></div>
      <div class="products-grid grid-mode">
      <template v-for="(product, index) in products" :key="product.id">
        <div class="item">
          <product
            :product="product"
            :type="type"
            @quickview="quickview"
          ></product>
        </div>
        <div class="item card" v-if="canInsertCards(index)" v-html="getCard(canInsertCards(index))"></div>
      </template>
      </div>
      <div class="row placeholder-row" v-if="loading">
        <div v-for="n in 30" :key="n" class="col-xl-3 col-lg-4 col-6">
          <div class="placeholder-container">
            <div class="content">
            </div>
          </div>
        </div>
      </div>
    </div>
    <teleport to="#shopSubjectContainer" v-if="subjects && subjects.length > 0">
    <div class="shop-subject-container" :class="{'show-all': showAllSubjects}">
      <div class="title">Shop by Subject</div>
      <div class="category-grid">
        <template v-for="(subject, index) in subjects" :key="subject.id">
          <div class="item" :class="{'d-none': (index > 11), 'd-none d-md-block': (index > 2 && index < 12)}">
            <a :href="subject.url">
              <img loading="lazy" :src="subject.image" :alt="subject.name" />
              <span><span v-html="subject.name"></span><span v-text="subjectSubtitle"></span></span>
            </a>
          </div>
        </template>
      </div>
      <div class="actions" :class="{'hidden-desktop': subjects.length < 13, 'hidden-mobile': subjects.length < 4}">
        <a href="#" class="btn btn-show-all" @click.prevent="showAllSubjects = !showAllSubjects">See More Subjects</a>
      </div>
    </div>
    </teleport>
    <div class="toolbar-bottom" ref="toolbar">
      <template v-if="loaded && products.length > 0">
        <div class="facets">
          <facets :total="total"></facets>
        </div>
        <progress :max="pages.length" :value="page" aria-hidden="true"></progress>
        <button type="button" class="button-load-more" v-if="page && pages && page < pages.length" @click.prevent="infiniteScroll()">Load More</button>
        <pagination :pages="pages" @paginate="paginate"></pagination>
      </template>
    </div>`,
    props: {
        products: Array,
        subcategories: Array,
        subjects: Array,
        cards: Array,
        cardsInterval: Number,
        total: Number,
        pages: Array,
        type: String,
    },
    data() {
        return {
            showAllSubjects: false,
            observer: null
        }
    },
    mounted () {
        this.observeGrid();
        // infinite scroll
        this.observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                this.infiniteScroll(true);
            }
        },{
            rootMargin: '0px 0px 300% 0px',
            threshold: 0
        });
        if(this.$refs.toolbar) {
            let timer = null;
            let count = 0;
            timer = setInterval(() => {
                if(this.loaded) {
                    clearInterval(timer);
                    setTimeout(() => {
                        this.observer.observe(this.$refs.toolbar);
                    },500);
                } else {
                    count += 1000;
                    if (count > 9000) clearInterval(timer);
                }
            },1000);
        }
    },
    destroyed() {
        this.observer.disconnect();
    },
    computed: {
        classObject() {
            return {
                'collection-canvas': this.type && this.type === 'canvas',
                'collection-mural': this.type && this.type !== 'canvas',
            }
        },
        subjectSubtitle() {
            if(this.type === 'canvas') {
                return 'Canvas Prints'
            } else if(this.type === 'wallpaper') {
                return 'Wallpaper'
            } else {
                return 'Wall Murals'
            }
        },
        cardsSize() {
            return this.cards.length;
        }
    },
    methods: {
        paginate(currentPage) {
            this.$emit('paginate', currentPage);
        },
        infiniteScroll(auto) {
            auto = (typeof auto === 'undefined') ? false : auto;
            const currentPage = (this.page + 1) <= this.pages.length ? this.page + 1 : null;
            if(currentPage) {
                this.$emit('infiniteScroll', currentPage, auto);
            }
        },
        quickview([product,description,type]) {
            this.$emit('quickview', [product,description,type]);
        },
        updateLimit(currentLimit) {
            this.$emit('updateLimit', currentLimit);
        },
        updateFilters(newFilters) {
            this.$emit('updateFilters', newFilters);
        },
        canInsertCards(index) {
            if(!this.hasFilters && !this.hasFiltersInUrl && this.cards.length > 0 && this.cardsInterval > 0 && this.products.length > this.cardsInterval) {
                const position = ((index + 1)%this.cardsInterval) === 0 ? ((index + 1) + ((this.page -1) * this.limit))/this.cardsInterval : 0;
                return (position > 0 && position <= this.cardsSize) ? position : 0;
            }
        },
        getCard(index) {
            if(this.cards[(index-1)] !== undefined) {
                let card = this.cards[(index-1)];
                let keyword = this.type.toLowerCase();
                let keywordP = (keyword === 'canvas') ? 'canvases' : keyword + 's';
                card = card.replace(/wall murals/g,keywordP);
                card = card.replace(/murals/g,keywordP);
                card = card.replace(/wall mural/g,keyword);
                if(this.type.toLowerCase() !== 'nural') {
                    card = card.replace(/mural/g,keyword);
                }
                return card;
            } else {
                return '';
            }
        }
    }
}
if(rootEl) {
    const collectionApp = Vue.createApp({
        components: {
            'collection': collectionComponent,
            'product': productComponent,
            'facets': facetsComponent,
            'filters': filtersComponent,
            'pagination': paginationComponent,
            'wishlistlink': wishlistLink
        },
        props: ['keyword','type','discount','partnerDiscount','metaTitle','metaDescription','collectionTitle','magentoId','handle','id','disableApi'],
        data() {
            return {
                products: [],
                ownPoducts: [],
                apiPoducts: [],
                subcategories: [],
                subjects: [],
                total: 0,
                ownPoductsTotal: 0,
                apiPoductsTotal: 0,
                accessToken: null,
                stock: null,
                iterator: null,
                cardsInterval: 0,
                cards: [],
                page: 1,
                limit: 60,
                pagesLoaded: 0,
                pages: [],
                hasFiltersInUrl: false,
                hasFilters: false,
                loading: true,
                loaded: false,
                productLoading: false,
                collectionType: this.type,
                addAdobeProducts: this.disableApi === 'false',
                productData: null,
                productSizes: null,
                productMaterials: null,
                apiFilters: {},
                cleanFilters: {
                    'type': 'all',
                    'orientation': 'all',
                    'units': 'inches',
                    'min_width': null,
                    'min_height': null,
                    'color': null,
                },
                appliedFilters: {
                    'type': 'all',
                    'orientation': 'all',
                    'units': 'inches',
                    'min_width': null,
                    'min_height': null,
                    'color': null,
                }
            }
        },
        created() {
            const params = new URLSearchParams(window.location.search);
            // filters
            for(const filter in this.cleanFilters) {
                if(params.has(filter) === true) {
                    this.appliedFilters[filter] = decodeURIComponent(params.get(filter));
                    this.hasFiltersInUrl = true;
                }
            }
            // page
            if(params.has('p') === true) {
                this.page = parseInt(params.get('p')) ? parseInt(params.get('p')) : 1
            }
            if(this.type === 'search') {
                if(params.has('search-type') === true) {
                    try {
                        localStorage.setItem('limitlesswalls_search_type', params.get('search-type'));
                    } catch (e) {
                        console.error('localStorage not supported');
                    }
                }
                try {
                    if(localStorage.getItem('limitlesswalls_search_type')) {
                        this.collectionType = localStorage.getItem('limitlesswalls_search_type');
                    } else {
                        this.collectionType = document.getElementById('#header-search-type').value;
                    }
                } catch (e) {
                    this.collectionType = 'mural';
                }
            }
            if(this.collectionType === 'wallpaper') {
                this.addAdobeProducts = false;
            }
        },
        computed: {
            getLimit() {
                return parseInt(this.limit);
            },
            getPage() {
                return parseInt(this.page);
            }
        },
        provide() {
            return {
                productLoading: Vue.computed(() => this.productLoading),
                productSizes: Vue.computed(() => this.productSizes),
                productMaterials: Vue.computed(() => this.productMaterials),
                page: Vue.computed(() => parseInt(this.page)),
                limit: Vue.computed(() => parseInt(this.limit)),
                loading: Vue.computed(() => this.loading),
                loaded: Vue.computed(() => this.loaded),
                appliedFilters: Vue.computed(() => this.appliedFilters),
                hasFiltersInUrl: Vue.computed(() => this.hasFiltersInUrl),
                hasFilters: Vue.computed(() => this.hasFilters),
                addAdobeProducts: Vue.computed(() => this.addAdobeProducts),
                cleanFilters: this.cleanFilters,
                discount: (this.partnerDiscount && window.customerIsPartner) ? this.partnerDiscount : this.discount
            }
        },
        mounted () {
            this.cardsInterval = window.limitlesswallsCardsInterval || 0;
            this.cards = window.limitlesswallsCards || [];
            if(this.collectionType === 'wallpaper' && this.id) {
                this.loadShopifyCollection();
            } else {
                this.loadMagentoCollection();
                this.loadSearch();
            }
        },
        methods: {
            loadShopifyCollection() {
                fetch(`${this.fetchCollectionUrl}?id=${encodeURIComponent(this.id)}`)
                    .then(res => res.json())
                    .then(data => {
                        if(data && data.hasOwnProperty('products')) {
                            this.ownPoducts = data.products;
                            this.ownPoductsTotal = data.products.length;
                        }
                    })
                    .catch(err => {

                    })
                    .finally(() => {
                        if(this.addAdobeProducts) {
                            if(this.hasFiltersInUrl) {
                                this.searchWithFilters();
                            } else {
                                this.search();
                            }
                        }
                        if(this.type !== 'search') {
                            if(this.collectionTitle) {
                                const dataLayerData = {
                                    'productList': this.collectionTitle,
                                    'pageType': 'Collection',
                                    'event': 'Collection'
                                };
                                this.updateDataLayer(dataLayerData);
                            }
                        }
                        this.getProducts();
                    });
            },
            loadMagentoCollection() {
                let url = this.collectionType === 'canvas' ? '/products/canvas' : '/products/mural';
                url += '?sections=api-product-data';
                axios.get(url).then((response) => {
                    if(response && response.hasOwnProperty('data') && response.data.hasOwnProperty('api-product-data')) {
                        const html = response.data['api-product-data'];
                        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                        this.productData = JSON.parse(parsedHTML.getElementById('product-json').textContent);
                        if(this.collectionType === 'canvas') {
                            this.productSizes = JSON.parse(parsedHTML.getElementById('product-sizes-json').textContent);
                        } else {
                            this.productMaterials = JSON.parse(parsedHTML.getElementById('product-materials-json').textContent);
                        }
                    }
                });
                let collectionUrl = null;
                if(this.magentoId !== '') {
                    collectionUrl = this.remoteApiUrl + 'shopify/collection/load?isAjax=1&id=' + this.magentoId + '&type=' + this.collectionType;
                } else if(this.collectionType === 'wallpaper' || this.type === 'search') {
                    collectionUrl = this.remoteApiUrl + 'shopify/collection/search?isAjax=1&q=' + this.keyword + '&type=' + this.collectionType;
                }
                new Promise((resolve, reject) => {
                    if(collectionUrl) {
                        axios.get(collectionUrl).then((category) => {
                            if(category && category.hasOwnProperty('data')) {
                                if(category.data.hasOwnProperty('subcategories') && category.data.subcategories.length > 0) {
                                    this.subcategories = category.data.subcategories;
                                }
                                if(category.data.hasOwnProperty('subjects') && category.data.subjects.length > 0) {
                                    this.subjects = category.data.subjects;
                                }
                                if(category.data.hasOwnProperty('products') && category.data.products.count > 0) {
                                    this.ownPoducts = category.data.products.items || [];
                                    this.ownPoductsTotal = category.data.products.count;
                                }
                            }
                        }).finally(() => {
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                }).finally(() => {
                    if(this.addAdobeProducts) {
                        if(this.hasFiltersInUrl) {
                            this.searchWithFilters();
                        } else {
                            this.search();
                        }
                    }
                    if(this.type !== 'search') {
                        if(this.metaTitle) {
                            document.title = this.metaTitle;
                        } else if(this.collectionTitle) {
                            document.title = this.collectionTitle;
                        }
                        if(this.metaDescription && document.querySelector('meta[name="description"]')) {
                            document.querySelector('meta[name="description"]').setAttribute("content", this.metaDescription);
                        }
                        if(this.collectionTitle) {
                            const dataLayerData = {
                                'productList': this.collectionTitle,
                                'pageType': 'Collection',
                                'event': 'Collection'
                            };
                            this.updateDataLayer(dataLayerData);
                        }
                    }
                    this.getProducts();
                });
            },
            loadSearch() {
                if(this.type === 'search') {
                    let url = this.collectionType === 'mural' ? '/collections/murals' : '/collections/'+this.collectionType;
                    url += '?sections=api-sidebar';
                    axios.get(url).then((response) => {
                        if(response && response.hasOwnProperty('data') && response.data.hasOwnProperty('api-sidebar')) {
                            try {
                                const html = response.data['api-sidebar'];
                                const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                                const sidebarHTML = parsedHTML.getElementById('shopify-section-api-sidebar').innerHTML;
                                let searchType = 'Wall Murals';
                                if(this.collectionType === 'canvas') {
                                    searchType = 'Canvas Prints';
                                } else if(this.collectionType === 'wallpaper') {
                                    searchType = 'Wallpaper';
                                }
                                const pageTitle = this.keyword + ' ' + searchType;
                                document.getElementById('category-navigation').innerHTML = sidebarHTML;
                                document.querySelector('.collection-hero__title').innerHTML = pageTitle;
                            } catch (e) {

                            }
                        }
                    });
                }
            },
            search() {
                let filters = this.cloneObject(this.xApiFilters);
                if(this.keyword) {
                    filters['search_parameters']['words'] = this.keyword;
                } else {
                    filters['search_parameters']['order'] = 'nb_downloads';
                }
                filters['search_parameters']['limit'] = this.getLimit;
                this.loading = true;
                this.hasFilters = false;
                this.apiFilters = this.cloneObject(filters);
            },
            searchWithFilters() {
                let filters = this.cloneObject(this.xApiFilters);
                if(this.keyword) {
                    filters['search_parameters']['words'] = this.collectionType === 'wallpaper' ? this.keyword + ' wallpaper' : this.keyword;
                } else {
                    filters['search_parameters']['order'] = 'nb_downloads';
                }
                filters['search_parameters']['limit'] = this.getLimit;
                // Image Type
                if(this.appliedFilters.type !== 'all') {
                    delete filters.search_parameters.filters_content_type_photo;
                    switch (this.appliedFilters.type) {
                        case 'photo':
                            filters['search_parameters']['filters_content_type_photo'] = 1;
                            break;
                        case 'illustration':
                            filters['search_parameters']['filters_content_type_illustration'] = 1;
                            break;
                        case 'vector':
                            filters['search_parameters']['filters_content_type_vector'] = 1;
                            break;
                    }
                }
                // Orientation
                if(this.appliedFilters.orientation !== 'all') {
                    switch (this.appliedFilters.orientation) {
                        case 'horizontal':
                            filters['search_parameters']['filters_orientation'] = 'horizontal';
                            break;
                        case 'vertical':
                            filters['search_parameters']['filters_orientation'] = 'vertical';
                            break;
                        case 'square':
                            filters['search_parameters']['filters_orientation'] = 'square';
                            break;
                        case 'panoramic':
                            filters['search_parameters']['filters_panoramic_on'] = 1;
                            break;
                    }
                }
                // Size
                const inMultiplier = 15;
                const cmToIn = 0.393701;
                let $width = null;
                let $height = null;
                if(this.appliedFilters.min_width && this.appliedFilters.min_width > 0) {
                    if(this.appliedFilters.units === 'inches') {
                        $width = this.appliedFilters.min_width * inMultiplier;
                    } else {
                        $width = this.appliedFilters.min_width * cmToIn * inMultiplier;
                    }
                }
                if(this.appliedFilters.min_height && this.appliedFilters.min_height > 0) {
                    if(this.appliedFilters.units === 'inches') {
                        $height = this.appliedFilters.min_height * inMultiplier;
                    } else {
                        $height = this.appliedFilters.min_height * cmToIn * inMultiplier;
                    }
                }
                if($width && !$height) {
                    $height = $width;
                } else if(!$width && $height) {
                    $width = $height;
                }
                if($width && $height) {
                    const $area = Math.ceil($width * $height);
                    filters['search_parameters']['filters_area_pixels'] =  '0-'+$area;
                }
                // Color
                if(this.appliedFilters.color) {
                    filters['search_parameters']['filters_colors'] = this.appliedFilters.color.replace('#','');
                }
                this.loading = true;
                this.hasFilters = true;
                this.apiFilters = this.cloneObject(filters);
            },
            getProducts(append) {
                append = (typeof append === 'undefined') ? false : append;
                const index = this.getPage - 1;
                let totalPages = Math.ceil(this.ownPoductsTotal / this.limit);
                if(totalPages < 1) {
                    totalPages = 1;
                }
                if(this.addAdobeProducts) {
                    const apiFilters = this.cloneObject(this.apiFilters);
                    apiFilters['p'] = index;
                    const lastPageQty = this.ownPoductsTotal % this.limit;
                    const apiItemsNeededOnLastPage = this.limit - lastPageQty;
                    fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(apiFilters), headers: this.fetchHeaders})
                        .then((response) => response.json())
                        .then((response) => {
                            if(response && response.files) {
                                this.apiPoducts = response.files;
                                this.apiPoductsTotal = parseInt(response.nb_results);
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                        })
                        .then(() => {
                            if(!this.hasFiltersInUrl && !this.hasFilters && this.ownPoductsTotal > 0 && this.getPage <= totalPages) { // Current page still containes real products
                                if(append) {
                                    this.products = this.products.concat(this.ownPoducts.slice((index * this.limit),(this.getPage * this.limit)));
                                } else {
                                    this.products = this.ownPoducts.slice((index * this.limit),(this.getPage * this.limit));
                                }
                                if(this.getPage === totalPages && apiItemsNeededOnLastPage > 0) { // Last page with real items
                                    this.products = this.products.concat(this.apiPoducts.slice(0,apiItemsNeededOnLastPage));
                                }
                            } else { // Page with API items only
                                if(append) {
                                    this.products = this.products.concat(this.apiPoducts);
                                } else {
                                    this.products = this.apiPoducts;
                                }
                            }
                            if(!this.loaded) {
                                this.total = this.ownPoductsTotal + this.apiPoductsTotal;
                                this.setPages();
                                if(this.type === 'search') {
                                    document.title = `Search: ${this.total} results found for "${this.keyword}" – Limitless Walls`;
                                    const dataLayerData = {
                                        'searchTerm': this.keyword,
                                        'pageType': "Search",
                                        'event': "Search"
                                    };
                                    this.updateDataLayer(dataLayerData);
                                }
                            }
                        }).finally(() => {
                            this.loading = false;
                            this.loaded = true;
                        });
                } else {
                    if(this.ownPoductsTotal > 0 && this.getPage <= totalPages) {
                        if(append) {
                            this.products = this.products.concat(this.ownPoducts.slice((index * this.limit),(this.getPage * this.limit)));
                        } else {
                            this.products = this.ownPoducts.slice((index * this.limit),(this.getPage * this.limit));
                        }
                    }
                    if(!this.loaded) {
                        this.total = this.ownPoductsTotal;
                        this.setPages();
                        this.loaded = true;
                    }
                    this.loading = false;
                }
            },
            paginate(newPage) {
                if(newPage) {
                    if(newPage > 1) {
                        this.setQueryStringParameter({'p':newPage});
                    } else {
                        this.setQueryStringParameter({'p':newPage},true);
                    }
                    this.loading = true;
                    this.page = parseInt(newPage);
                    this.getProducts();
                    this.scrollTo(0);
                }
            },
            infiniteScroll(newPage, auto) {
                if(newPage && !this.loading) {
                    if(auto) {
                        if(this.pagesLoaded >= 2) {
                            return;
                        } else {
                            this.pagesLoaded++;
                        }
                    } else {
                        this.pagesLoaded = 0;
                    }
                    if(newPage > 1) {
                        this.setQueryStringParameter({'p':newPage});
                    } else {
                        this.setQueryStringParameter({'p':newPage},true);
                    }
                    this.loading = true;
                    this.page = parseInt(newPage);
                    this.getProducts(true);
                }
            },
            updateLimit(newLimit) {
                this.loading = true;
                this.page = 1;
                this.limit = newLimit;
                this.search();
                this.getProducts();
                this.scrollTo(0);
            },
            updateFilters(newFilters) {
                this.appliedFilters = newFilters;
                let reset = true;
                let newParams = {'p':null};
                for(const filter in this.appliedFilters) {
                    newParams[filter] = null;
                    if(this.cleanFilters[filter] !== this.appliedFilters[filter]) {
                        newParams[filter] = this.appliedFilters[filter];
                        reset = false;
                    }
                }
                this.page = 1;
                if(reset) {
                    this.search();
                    this.setQueryStringParameter(newParams, true);
                } else {
                    this.searchWithFilters();
                    this.setQueryStringParameter(newParams);
                }
                this.getProducts();
            },
            setPages() {
                let newPages = [];
                let numberOfPages = Math.ceil(this.total / this.getLimit);
                // limit total number of pages to 25
                if(numberOfPages > 25) {
                    numberOfPages = 25;
                }
                for (let index = 1; index <= numberOfPages; index++) {
                    newPages.push(index);
                }
                this.pages = newPages;
            },
            quickview([product,description,type]) {
                this.downloadAsset([product,description,type]);
            },
            scrollTo(pos) {
                window.scrollTo({ top: pos, behavior: 'instant' });
            },
            setQueryStringParameter(newParams, remove) {
                const currentParams = new URLSearchParams(window.location.search);
                remove = (typeof remove === 'undefined') ? false : remove;
                if(remove) {
                    for(const name in newParams) {
                        currentParams.delete(name);
                    }
                } else {
                    for(const name in newParams) {
                        if(newParams[name]) {
                            currentParams.set(name, encodeURIComponent(newParams[name]));
                        } else {
                            currentParams.delete(name);
                        }
                    }
                }
                window.history.pushState('', '', window.location.pathname + '?' + currentParams.toString());
            },
            downloadAsset([product,description,type]) {
                try {
                    if(product.entity_id) {
                        const modalBody =
                            `<div class="image"><img src="${product.thumbnail_url}" alt=""></div>`;
                        const modalFooter =
                            `<div class="info">
                                <div class="buttons">
                                    <a href="${this.getUrl(product,type)}" class="product-button">Choose Options</a>
                                </div>
                                <div class="product">
                                    <p class="name">${description}</p>
                                </div>
                            </div>`;
                        store.dispatch('modal/set', {
                            'modalBody': modalBody,
                            'modalFooter': modalFooter
                        })
                        this.openModal();
                    } else if(product.hasOwnProperty('shopify') && product.shopify) {
                        this.productLoading = product.id;
                        const productUrl = '/products/' + product.url;
                        const modalBody =
                            `<div class="image"><img src="${product.thumbnail_url}" alt=""></div>`;
                        const modalFooter =
                            `<div class="info">
                                <div class="buttons">
                                    <a href="${productUrl}" class="product-button">Choose Options</a>
                                </div>
                                <div class="product">
                                    <p class="name">${description}</p>
                                </div>
                            </div>`;
                        store.dispatch('modal/set', {
                            'modalBody': modalBody,
                            'modalFooter': modalFooter
                        })
                        this.openModal();
                    } else {
                        this.productLoading = product.id;
                        let url = this.remoteApiUrl + 'shopify/api/download?id='+product.id;
                        axios.get(url).then((response) => {
                            if(response.data && response.data.url) {
                                const productUrl = this.getProductUrl({image: response.data.url, id: product.id, title: description});
                                const modalBody =
                                    `<div class="image"><img src="${response.data.url}" alt=""></div>`;
                                const modalFooter =
                                    `<div class="info">
                                <div class="buttons">
                                    <a href="${productUrl}" class="product-button">Choose Options</a>
                                </div>
                                <div class="product">
                                    <p class="name">${description}</p>
                                </div>
                            </div>`;
                                store.dispatch('modal/set', {
                                    'modalBody': modalBody,
                                    'modalFooter': modalFooter
                                })
                                this.openModal();
                            }
                        }).finally(() => {
                            this.productLoading = null;
                        });
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            getProductUrl(params) {
                const title = btoa(params.title);
                let url = '/products/'+this.collectionType+'?imageId=' + params.id + '&title=' + title;
                try {
                    url = '/products/'+this.collectionType+'?image=' + btoa(params.image) + '&imageId=' + params.id + '&title=' + title;
                } catch (e) {
                    console.error(e);
                }
                return url;
            },
            openModal() {
                store.dispatch('modal/open')
            },
            closeModal() {
                store.dispatch('modal/close')
            },
        }
    }, { ...rootEl.dataset })
    collectionApp.use(AdobeClientPlugin).use(store);
    collectionApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('swatches')
    collectionApp.config.unwrapInjectedRef = true
    collectionApp.mount('#collectionApp');
}

